export const userActionType = { SET_CURRENT_USER: 'SET_CURRENT_USER', ADD_NOTIFICATION: 'ADD_NOTIFICATION', ADD_NOTIFICATIONS: 'ADD_NOTIFICATIONS' };
